import { useFormEngineContext } from './formContext'
import { MultiSelect, Mselect2Config } from './Widgets'
import { FormValidator } from './formInterfaces'
import { useFieldContext } from './fieldInstanceContext'
import { FormActionKind } from './formReducer'

export const GroupWidget = (props: {
    field: { [s: string]: any }
    fieldSetInstance: any
    setIndex: number
    updateFieldValue: (val: any) => void
    fieldIndex?: number
}) => {
    try {
        const { field, fieldSetInstance, setIndex, fieldIndex, updateFieldValue } = props

        const { formState, formDispatch } = useFormEngineContext()
        const { fieldState, fieldDispatch } = useFieldContext()

        const validatorMeta = formState.validatorMetaMap[formState.templateType]

        const vSegFieldCount = () => {
            let vCount = 0
            formState.schema.sections.forEach(function (section: { instances: { fields: any }[] }) {
                const fields = section.instances[0].fields
                fields.forEach(function (otherField: { [s: string]: any }) {
                    if (
                        otherField.type == 'single-select-dropdown' ||
                        otherField.type == 'multi-select-dropdown'
                    )
                        vCount++
                })
            })
            return vCount
        }

        const getDataForMultiSelectFields = () => {
            let mapVar = {} as { [s: string]: any }
            // var schemaInstances = formState.schema.sections[0].instances[0].fields
            var schemaInstances = fieldState.fieldInstances
                ? fieldState.fieldInstances[0].fields
                : []
            let schemaWithLists = schemaInstances.filter(function (instance: { type: string }) {
                return (
                    instance.type == 'single-select-dropdown' ||
                    instance.type == 'multi-select-dropdown'
                )
            })
            schemaWithLists.forEach(function (list: any, idx: string | number) {
                if (typeof schemaWithLists[idx].domain == 'string')
                    // Modify this later to check on radio/checkbox/dropdown
                    schemaWithLists[idx].domain = JSON.parse(schemaWithLists[idx].domain)
                mapVar[schemaWithLists[idx].id] = schemaWithLists[idx].domain
            })
            return mapVar
        }
        if (
            field.type.toLowerCase() == 'single-select-dropdown' ||
            field.type.toLowerCase() == 'multi-select-dropdown'
        ) {
            // Multi Select
            const vCount = vSegFieldCount()
            let multiSelectList = {} as { [s: string]: any }
            // const tempFieldInstance = JSON.parse(JSON.stringify(fieldSetInstance)) as {
            //     [s: string]: any
            // }
            // if (field.multiSelectSections != null) {
            //     field.value = JSON.parse(field.multiSelectSections)
            //     field.value.map(function (item: { key: any; value: any }, i: any) {
            //         tempFieldInstance.fields.map(function (
            //             CheckField: { id: any },
            //             Id: string | number
            //         ) {
            //             if (CheckField.id == item.key && field.fieldValue.includes(item.value)) {
            //                 tempFieldInstance.fields[Id].value = 1
            //             } else if (CheckField.id == item.key) {
            //                 var validators = validatorMeta.filter(function (
            //                     relation: FormValidator
            //                 ) {
            //                     return relation.parent == item.key && parseInt(relation.id) > 0
            //                 })

            //                 tempFieldInstance.fields.forEach(function (f: {
            //                     id: any
            //                     type: string
            //                     fieldValue: string[]
            //                 }) {
            //                     validators.forEach(function (v: { id: any }) {
            //                         if (f.id == v.id && tempFieldInstance.fields[Id].value == 0) {
            //                             if (f.type == 'radio') f.fieldValue = ['Unknown']
            //                             else f.fieldValue = []
            //                         }
            //                     })
            //                 })
            //             }
            //         })
            //     })
            //     const tempInstances = fieldState.fieldInstances ?? []
            //     tempInstances[setIndex] = tempFieldInstance
            // }

            if (vCount > 0) {
                const multiSelectMap = getDataForMultiSelectFields()
                const list = multiSelectMap[field.id]
                if (list) {
                    const selectedSegs = list.filter(function (name: { value: any }) {
                        return field.fieldValue != null
                            ? field.fieldValue.indexOf(name.value) > -1
                            : null
                    })
                    multiSelectList = Mselect2Config(
                        field.multiple,
                        list,
                        null,
                        selectedSegs,
                        { width: '100%', height: '60px' },
                        field.id
                    )

                    // var thisLesKey = tempFieldInstance.lesionKey;

                    // TODO update field at context level here
                    multiSelectList.onChange = function (value: any) {
                        if (value !== null) {
                            // TODO: only needed if postMultiSelVal function is still needed (See comment below)
                            // let mapVar = value.map(
                            //     function (vv: any) {
                            //         var num = -2;
                            //         multiSelectMap[field.id].forEach(
                            //             function (vs: { value: any; key: number; }, index: any) {
                            //                 if (vs.value === vv) num = vs.key;
                            //         });
                            //         //if (number === -2) return -1;
                            //         return num;
                            //     }
                            // );
                            field.value = value
                            // TODO: is the postMultiSelVal function still used? In the old code it looks like it does nothign
                            // if (thisLesKey) {
                            //     postMultiSelVals(value, mapVar, thisLesKey);
                            // } else {
                            //     postMultiSelVals(value, mapVar, null);
                            // }
                        }
                    }
                }
            }

            const viewCompo = (
                <MultiSelect
                    multiple={multiSelectList.multiple}
                    id={multiSelectList.id}
                    optionsList={multiSelectList.optionsList}
                    selectedValuesProp={multiSelectList.selectedValuesProp}
                    style={multiSelectList.style}
                    field={field}
                    setIndex={setIndex}
                    fieldIndex={fieldIndex}
                />
            )
            const domid = 'field' + field.id
            return <div id={domid}>{viewCompo}</div>
        } else if (field.type.toLowerCase() == 'checkboxgroup') {
            // Checkbox Group logic

            // field.value should have original JSON schema, hence get it from the multiselectsections list
            field.value = JSON.parse(field.multiSelectSections)

            if (field.value != null) {
                // below won't work as moved from single flag entry to vertical tables
                // control.setPrevValue(field.id, field.value);
                // new logic update checkbox selection
                // const tempFieldInstance = JSON.parse(JSON.stringify(fieldSetInstance)) as {
                //     [s: string]: any
                // }
                let isChecked = false
                return (
                    <div>
                        {field.value.map(function (item: { key: any; value: any }, i: any) {
                            // tempFieldInstance.fields.map(function (
                            //     CheckField: { id: any },
                            //     index: number
                            // ) {
                            //     if (CheckField.id == item.key && field.value.includes(item.value)) {
                            //         tempFieldInstance.fields[index].value = 1
                            //     } else if (CheckField.id == item.key) {
                            //         var validators = validatorMeta.filter(function (
                            //             relation: FormValidator
                            //         ) {
                            //             return (
                            //                 relation.parent == item.key && parseInt(relation.id) > 0
                            //             )
                            //         })

                            //         tempFieldInstance.fields.forEach(function (f: {
                            //             id: any
                            //             type: string
                            //             fieldValue: string[]
                            //         }) {
                            //             validators.forEach(function (v: { id: any }) {
                            //                 if (
                            //                     f.id == v.id &&
                            //                     tempFieldInstance.fields[index].value == 0
                            //                 ) {
                            //                     if (f.type == 'radio') f.fieldValue = ['Unknown']
                            //                     else f.fieldValue = []
                            //                 }
                            //             })
                            //         })
                            //     }
                            // })
                            const key = item.key

                            let foundElement = validatorMeta.find(function (
                                element: FormValidator
                            ) {
                                return element.parent === key && parseInt(element.id) > 0
                            })
                            let metadataid = ''
                            if (foundElement) {
                                metadataid = foundElement.id
                            }

                            try {
                                if (field.fieldValue)
                                    isChecked = field.fieldValue.includes(item.value)
                            } catch (e) {
                                console.error(e)
                            }
                            const domid = `field${field.id}_${setIndex}_${i}`
                            return (
                                <div className="radio-float-left w-auto">
                                    <label>
                                        <input
                                            type="checkbox"
                                            disabled={formState.isReadOnly}
                                            name={'field' + field.id}
                                            value={key}
                                            checked={isChecked}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                const currentValues: Set<any> = new Set(
                                                    field.fieldValue
                                                )
                                                const tempSchema = { ...formState.schema }
                                                const parentIndex =
                                                    tempSchema.sections[0]?.instances[
                                                        setIndex
                                                    ]?.fields.findIndex(
                                                        (field: any) => field.id == item.key
                                                    )
                                                if (e.target.checked) {
                                                    currentValues.add(item.value)
                                                    if (parentIndex > -1)
                                                        tempSchema.sections[0].instances[
                                                            setIndex
                                                        ].fields[parentIndex].value = 1
                                                } else {
                                                    currentValues.delete(item.value)
                                                    if (parentIndex > -1)
                                                        tempSchema.sections[0].instances[
                                                            setIndex
                                                        ].fields[parentIndex].value = 0
                                                }
                                                updateFieldValue(Array.from(currentValues))
                                                formDispatch({
                                                    type: FormActionKind.setSchema,
                                                    payload: tempSchema,
                                                })
                                            }}
                                        />
                                        <span className="checkable">{item.value}</span>
                                    </label>
                                </div>
                            )
                        })}
                    </div>
                )
            } else {
                return <></>
            }
        } else if (field.type.toLowerCase() == 'radio') {
            return (
                <>
                    <div>
                        {field.domain != null ? (
                            field.domain.map(function (
                                item: {
                                    value: any
                                    key: string | number | readonly string[] | undefined
                                },
                                i: number
                            ) {
                                let radioState = false
                                try {
                                    if (field.fieldValue) {
                                        radioState = field.fieldValue.includes(item.value)
                                    }
                                } catch (e) {
                                    console.error(e)
                                }

                                let domId = `field${field.id}_${setIndex}_${i}`
                                return (
                                    <div className="radio-float-left w-auto">
                                        <label>
                                            <input
                                                id={domId}
                                                disabled={formState.isReadOnly}
                                                type="radio"
                                                name={'field' + field.id}
                                                value={item.key}
                                                checked={radioState}
                                                onChange={(
                                                    e: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    const currentValues = field.fieldValue ?? []
                                                    currentValues[0] = field.domain[i]?.value

                                                    updateFieldValue(currentValues)
                                                }}
                                            />
                                            <span className="checkable">{item.value}</span>
                                        </label>
                                    </div>
                                )
                            })
                        ) : (
                            <div className="radio-float-left w-auto" style={{ color: 'red' }}>
                                Domain not Found for Widget
                            </div>
                        )}
                    </div>
                    {formState.lockedStatus ||
                    (!formState.lockedData?.isGlobal && !formState.isReadOnly) ? (
                        <a
                            onClick={() => {
                                // Need to handle 1. reset fieldValue to unkonw
                                // 2. reset fieldIndex to []
                                if (!formState.isReadOnly) {
                                    updateFieldValue(['Unknown'])
                                    console.error('need to handle reset fieldindex')
                                    // $('input:radio[name=' + "field{0}".at(field.id) + ']').each(function () {
                                    //     $(this).prop('checked', false);
                                    //     field.fieldValue = ["Unknown"];
                                    //     field.fieldIndex = [];
                                    // });
                                }
                            }}
                            style={{ cursor: 'pointer', float: 'right' }}
                        >
                            Reset
                        </a>
                    ) : (
                        <></>
                    )}
                </>
            )
        }
    } catch (e) {
        console.error(e)
        return <span style={{ color: 'red' }}>Component failed</span>
    }
}
